/**
 * Main App Component
 */
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, useLocation } from 'react-router-dom';
import { authAPI } from './services/api';
import Login from './components/Login';
import WorkspacePages from './components/WorkspacePages';
import WorkspaceNavigation from './components/WorkspaceNavigation';
import WorkspacePreloader from './components/WorkspacePreloader';
import { preloadPage } from './pageLoaders';
import Companies, { CompanyAccess, CompanyWorkspace } from './components/Companies';
import './App.css';
import './ThemeRefresh.css';
import './DarkTheme.css';
import './Mobile.css';

const ChatInterface = lazy(() => preloadPage('/chat'));
const KnowledgeBase = lazy(() => preloadPage('/knowledge'));
const AgentConnections = lazy(() => preloadPage('/agent-connections'));
const PersonalAccount = lazy(() => preloadPage('/account'));
const Reports = lazy(() => preloadPage('/reports'));
const Evaluations = lazy(() => preloadPage('/evaluations'));
const CompanySettings = lazy(() => preloadPage('/subscription'));
const Dashboards = lazy(() => preloadPage('/dashboards'));
const Domains = lazy(() => preloadPage('/domains'));

const pages = {
  '/subscription': <CompanySettings />,
  '/account': <PersonalAccount />,
  '/chat': <ChatInterface />,
  '/knowledge': <KnowledgeBase />,
  '/agent-connections': <AgentConnections />,
  '/domains': <Domains />,
  '/reports': <Reports />,
  '/evaluations': <Evaluations />,
  '/dashboards': <Dashboards />,
};

function AppContent() {
  const { pathname } = useLocation();
  if (pathname === '/company-settings') return <Navigate to="/subscription" replace />;
  if (pathname === '/platform') return <Companies />;
  if (pathname === '/company-access') return <CompanyAccess />;
  if (pathname === '/login') return <Login />;
  if (!authAPI.isAuthenticated()) return <Navigate to="/login" replace />;
  if (!pages[pathname]) return <Navigate to="/chat" replace />;
  // Never retain one account's screen state across a change of login.
  return <CompanyWorkspace integratedSwitcher key={sessionStorage.getItem('access_token')}><WorkspaceNavigation><Suspense fallback={<div className="workspace-loading" role="status"><span className="workspace-spinner" />Loading workspace…</div>}><WorkspacePreloader /><WorkspacePages pages={pages} /></Suspense></WorkspaceNavigation></CompanyWorkspace>;
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
